import { createSelector } from '@reduxjs/toolkit'
import { RootState } from '../../types'

const selectAuthState = (state: RootState) => state.auth

/**
 * Selector para obter o usuário atual
 */
export const selectUser = createSelector(
  [selectAuthState],
  (auth) => auth.user
)

/**
 * Selector para verificar se o usuário está autenticado
 */
export const selectIsAuthenticated = createSelector(
  [selectAuthState],
  (auth) => auth.isAuthenticated
)

/**
 * Selector para verificar se está carregando
 */
export const selectAuthLoading = createSelector(
  [selectAuthState],
  (auth) => auth.isLoading
)

/**
 * Selector para verificar se está verificando autenticação
 */
export const selectIsCheckingAuth = createSelector(
  [selectAuthState],
  (auth) => auth.isCheckingAuth
)

/**
 * Selector para obter erro de autenticação
 */
export const selectAuthError = createSelector(
  [selectAuthState],
  (auth) => auth.error
)

/**
 * Selector para obter o token
 */
export const selectToken = createSelector(
  [selectAuthState],
  (auth) => auth.token
)

